import { getSessionUserId } from './session';

/**
 * Recently visited records, for the command palette's empty state.
 * localStorage only — a per-viewer convenience, never authoritative.
 *
 * Kept PER ACCOUNT (`keepr.recents:<userId>`): one unkeyed list outlived the
 * sign-out, so the next account on the browser was offered the last one's
 * record titles whenever the server history had not loaded. Signed out,
 * there are none.
 */

const LEGACY_KEY = 'keepr.recents';
const MAX = 12;

const keyFor = userId => (userId ? `${LEGACY_KEY}:${userId}` : null);

export const readRecents = () => {
	const key = keyFor(getSessionUserId());
	if (!key) return [];
	try {
		const parsed = JSON.parse(window.localStorage.getItem(key) || '[]');
		return Array.isArray(parsed) ? parsed : [];
	} catch {
		return [];
	}
};

/**
 * entry: { type: 'collection' | 'card' | 'item', id, title, path }
 * Newest first, deduped by path.
 */
export const pushRecent = (entry) => {
	if (!entry?.path || !entry?.title) return;
	const key = keyFor(getSessionUserId());
	if (!key) return;
	try {
		const rest = readRecents().filter(existing => existing?.path !== entry.path);
		window.localStorage.setItem(key, JSON.stringify([entry, ...rest].slice(0, MAX)));
		// The unkeyed list is nobody's in particular any more.
		window.localStorage.removeItem(LEGACY_KEY);
	} catch { /* convenience only */ }
};
